import { render, staticRenderFns } from "./UserDrawer.vue?vue&type=template&id=794c4494&scoped=true&"
import script from "./UserDrawer.vue?vue&type=script&lang=js&"
export * from "./UserDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794c4494",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAppBar,VAvatar})
